<template>
  <b-card class="bg-white rounded-xl">
    <div class="flex items-center">
      <div class="mr-2" @click="handleClick('podcast-category')">
        <feather-icon
          icon="ChevronLeftIcon"
          svgClasses="w-7 h-7 font-bold text-black cursor-pointer"
          class=""
        ></feather-icon>
      </div>
      <h2 class="text-2xl font-semibold mt-4 mb-4">Edit Category</h2>
    </div>

    <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
      <b-form role="form" @submit.prevent="handleSubmit(onSubmit)">
        <base-input
          alternative
          class="mb-3"
          name="Title"
          placeholder="Heading"
          :rules="{ required: true }"
          v-model="category_data.name"
          maxlength="200"
        >
        </base-input>
        <!-- <base-input
          alternative
          class="mb-3"
          name="Description"
          :rules="{ required: true }"
          placeholder="Description"
          v-model="category_data.description"
          maxlength="1000"
        >
        </base-input> -->
        <b-form-group label="Description">
          <quill-editor
            v-model="category_data.description"
            :options="editorOption"
            class="quill-h200px my-2"
          />
        </b-form-group>

        <div
          class="text-sm text-gray-600 font-medium px-2 py-1 mb-1 border rounded bg-gray-100 inline-block"
        >
          Recommended Size: 700 × 500px
        </div>
        <FileUploader
          v-show="!image"
          :image="image"
          :onSuccess="handleSuccess"
        />

        <div v-if="image">
          <p class="mb-2 text-danger">Image Preview</p>

          <div class="flex cursor-pointer items-center my-2" v-if="image">
            <base-button type="danger" class="px-8" @click="handleRemove">
              Remove image
            </base-button>
          </div>
          <span v-if="imageErr" class="small text-danger">{{ msg.image }}</span>
          <img v-if="image" :src="image" ref="cover" />
        </div>

        <div class="mt-3 mb-4">
          <p class="mb-2">Uploaded Image</p>
          <img
            class="w-1/2"
            alt="uploaded-image"
            :src="$imageURL + '/' + category_data.image"
          />
        </div>

        <div class="grid grid-cols-2 gap-4 mt-3">
          <div>
            <p class="mb-1">Meta Title</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="category_data.metaTitle"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Description</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="category_data.metaDesc"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Canonical Tag</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="category_data.metaCanonicalTag"
            >
            </base-input>
          </div>
          <div>
            <p class="mb-1">Meta Keyword</p>
            <base-input
              class="mb-3"
              name="designation"
              placeholder="Enter"
              v-model="category_data.metaKeyword"
            >
            </base-input>
          </div>
        </div>

        <base-button
          type="primary"
          outline
          class="w-full my-2"
          native-type="submit"
          >Save</base-button
        >
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import FileUploader from "@/components/FileUploader";

import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";

import { mapState } from "vuex";

export default {
  components: {
    FileUploader,
    quillEditor,
  },
  data() {
    return {
      image: "",
      icon: "",
      coverImage: "",
      type: "",
      Ctags: [],
      editorOption: {
        theme: "snow",
      },
      typeOption: [
        {
          value: "main",
          label: "Main",
        },
        {
          value: "other",
          label: "Other",
        },
      ],
      pageData: {},
      category_data: {},
      imageErr: false,
      msg: {},
    };
  },
  computed: {
    ...mapState("podcast", {
      selectedCategory: "selectedCategory",
    }),
  },
  watch: {
    pageData(val) {
      this.category_data = { ...val };
      // console.log(this.category_data);
    },
  },
  methods: {
    handleSuccess(image) {
      console.log(image);

      this.imageErr = false;

      if (!image.type.startsWith("image/")) {
        this.$swal.fire({
          title: "Invalid File",
          text: "Please upload an image file only!",
          // html: "<p style='text-align:center'>Please ensure that the file size does not exceed 5MB</p>",
          icon: "error",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      let mByte = 5 * 1048576;
      if (image.size > mByte) {
        this.$swal.fire({
          title: "File size exceeds the allowed limit!",
          text: "Please ensure that the file size does not exceed 5MB",
          icon: "warning",
          confirmButtonColor: "#830c81",
          confirmButtonText: "Okay",
        });
        return;
      }

      this.coverImage = image;
      this.readerData(image);
    },

    readerData(rawFile) {
      let loader = this.$loading();

      const reader = new FileReader();
      reader.onload = (e) => {
        this.$emit("load", (this.image = e.target.result));

        loader.close();
      };
      reader.readAsDataURL(rawFile);
    },
    async onSubmit() {
      let FormData = require("form-data");
      let data = new FormData();
      data.append("_id", this.category_data._id);
      data.append("name", this.category_data.name);
      data.append("image", this.coverImage);
      if (this.category_data.description)
        data.append("description", this.category_data.description);
      if (!this.category_data.description) {
        this.$notify.error({
          message: "Description is required",
          position: "top-right",
        });
        return;
      }
      data.append("metaKeyword", this.category_data.metaKeyword);
      data.append("metaCanonicalTag", this.category_data.metaCanonicalTag);
      data.append("metaDesc", this.category_data.metaDesc);
      data.append("metaTitle", this.category_data.metaTitle);

      let loader = this.$loading();
      try {
        const editData = await this.$store.dispatch(
          "podcast/update_category",
          data
        );
        console.log("editData", editData);

        loader.close();
        if (editData.data.status == 202) {
          const errmsg = editData.data.message;
          this.$swal.fire({
            title: "INFO",
            text: errmsg || "Something went wrong",
            icon: "info",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
          });
        } else if (editData.code == 200) {
          this.$router.push({ name: "podcast-category" });
          this.$swal.fire({
            text: "Your category has been successfully edited",
            icon: "success",
            confirmButtonText: "Okay",
            confirmButtonColor: "#830c81",
            showCancelButton: false,
          });
          loader.close();
        }
      } catch (error) {
        if (error) {
          loader.close();
        }
      }
    },
    async init() {
      this.pageData = this.selectedCategory;
    },
    handleRemove() {
      this.image = null;
      this.coverImage = null;
    },
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.h300px {
  height: 300px !important;
}
.imgupload {
  height: 270px !important;
}
</style>
